// extracted by mini-css-extract-plugin
export var header = "_sv-1";
export var maskBottom = "_sv-6";
export var maskMiddle = "_sv-7";
export var maskTop = "_sv-5";
export var root = "_sv-0";
export var scrollDownButton = "_sv-3";
export var scrollDownButtonHidden = "_sv-4";
export var viewport = "_sv-2";